import { LOCALITY_FILTERS, type LocalityFilter, type LocalityGroup } from '@shared/locality';

interface LocalityFilterRowProps {
  value: LocalityFilter;
  onChange: (next: LocalityFilter) => void;
  counts?: Partial<Record<LocalityGroup, number>>;
  loading?: boolean;
}

export function LocalityFilterRow({ value, onChange, counts }: LocalityFilterRowProps) {
  return (
    <div className="segment-row" role="tablist" aria-label="Location">
      {LOCALITY_FILTERS.map((f) => (
        <button
          key={f.key}
          type="button"
          role="tab"
          aria-selected={value === f.key}
          className={`segment ${value === f.key ? 'segment--active' : ''}`}
          onClick={() => onChange(f.key)}
        >
          {f.label}
          {counts && (
            <span className="segment__count">
              {f.key === 'both'
                ? (counts.inside ?? 0) + (counts.outside ?? 0)
                : (counts[f.key] ?? 0)}
            </span>
          )}
        </button>
      ))}
    </div>
  );
}
